import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../Dashboard/_services/users.service';
import { AlertService } from '../../Dashboard/_services/alert.service';

// Site Settings: super admins (S-ADMIN) only.
export const siteSettingsGuard = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const alertService = inject(AlertService);
  if (userService.isSuperAdmin()) {
    return true;
  }
  alertService.alert('You do not have permission to access this page', 'error');
  return router.navigate(['/sales']);
};

// Any other super-admin-only page (Postcodes): same rule.
export const superAdminGuard = siteSettingsGuard;
